import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import StatCards from '../components/Dashboard/StatCards';
import ChartsSection from '../components/Charts/ChartsSection';
import AlertsSection from '../components/Dashboard/AlertsSection';
import FilterBar from '../components/Tenders/FilterBar';
import TenderTable from '../components/Tenders/TenderTable';
import TenderForm from '../components/Tenders/TenderForm';
import ExportTools from '../components/Common/ExportTools';
import ImportExcel from '../components/Common/ImportExcel';
import ImportCsvTenders from '../components/Common/ImportCsvTenders';
import SettingsPage from './SettingsPage';
import SpreadsheetPage from '../components/Spreadsheet/SpreadsheetPage';
import AgentPage from '../components/Agent/AgentPage';
import { useTenders } from '../hooks/TenderContext';
import { TENDER_SUB_PAGES } from '../utils/constants';

const DashboardPage = () => {
  const { selectedCategory, filteredTenders } = useTenders();
  const [importOpen, setImportOpen] = useState(false);

  // Sub-page state for tender-specific spreadsheets
  const [subPage, setSubPage] = useState(null); // { tender, pageKey }

  const showDashboard = selectedCategory === 'all';
  const showSettings = selectedCategory === 'settings';
  const showProjectsDB = selectedCategory === 'projects_db';
  const showContactsDB = selectedCategory === 'contacts_db';
  const showAgent = selectedCategory === 'ai_agent';

  // Settings page
  if (showSettings) {
    return <SettingsPage />;
  }

  // AI Agent
  if (showAgent) {
    return <AgentPage />;
  }

  // Projects database - spreadsheet
  if (showProjectsDB) {
    return (
      <SpreadsheetPage
        storageKey="db_projects"
        title="מאגר מידע פרויקטים"
      />
    );
  }

  // Contacts database - spreadsheet
  if (showContactsDB) {
    return (
      <SpreadsheetPage
        storageKey="db_contacts"
        title="מאגר אנשי מפתח"
      />
    );
  }

  // Tender sub-page (conditions, quality, clarifications, tasks)
  if (subPage) {
    const spConfig = TENDER_SUB_PAGES.find(s => s.key === subPage.pageKey);
    return (
      <SpreadsheetPage
        storageKey={`tender_${subPage.tender.rowKey}_${subPage.pageKey}`}
        title={`${spConfig?.label || subPage.pageKey} — ${subPage.tender.subject}`}
        onBack={() => setSubPage(null)}
      />
    );
  }

  // Handler for opening sub-pages from TenderTable
  const handleOpenSubPage = (tender, pageKey) => {
    setSubPage({ tender, pageKey });
  };

  return (
    <Box>
      {/* Dashboard view: Stats + Charts + Alerts */}
      {showDashboard && (
        <>
          <StatCards />
          <ChartsSection />
          <AlertsSection />
        </>
      )}

      {/* Filter + Export Bar */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1, flexWrap: 'wrap', gap: 1 }}>
        <Box sx={{ flex: 1, minWidth: 300 }}>
          <FilterBar />
        </Box>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <ImportCsvTenders />
          <ExportTools />
        </Box>
      </Box>

      {/* Count */}
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        {filteredTenders.length} מכרזים
      </Typography>

      {/* Table */}
      <TenderTable onOpenSubPage={handleOpenSubPage} />

      {/* Form Dialog */}
      <TenderForm />

      {/* Import Dialog */}
      <ImportExcel open={importOpen} onClose={() => setImportOpen(false)} />
    </Box>
  );
};

export default DashboardPage;
